import { IconButton, IconButtonProps } from "@chakra-ui/react";
import { SwiperClass } from "swiper/react";
import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "~/images/svgs";
import { useIsMobile } from "~/lib/hooks";

type Props = Partial<IconButtonProps> & {
  next?: boolean;
  swiper?: SwiperClass;
};

export const CarouselButton = ({ next, swiper, ...props }: Props) => {
  const isMobile = useIsMobile();
  const [disabled, setDisabled] = useState<boolean>(false);
  useEffect(() => {
    if (swiper) {
      setDisabled(next ? swiper.isEnd : swiper.isBeginning);
      swiper.on("slideChange", ({ isBeginning, isEnd }) =>
        setDisabled(next ? isEnd : isBeginning)
      );
    }
  }, [swiper, next]);
  if (isMobile) return null;
  const Icon = next ? ChevronRight : ChevronLeft;
  return (
    <IconButton
      isDisabled={disabled}
      colorScheme="sage"
      isRound
      aria-label="previous slide"
      icon={<Icon fontSize={25} />}
      onClick={() => (next ? swiper?.slideNext() : swiper?.slidePrev())}
      {...props}
    />
  );
};
